import { Article } from "../types/Article";

export function classifyArticles(articles: Article[]): Record<'A' | 'A2' | 'B' | 'C' | 'Q', Article | null> {
    const result: Record<'A' | 'A2' | 'B' | 'C' | 'Q', Article | null> = {
        A: null,
        A2: null,
        B: null,
        C: null,
        Q: null,
    };

    console.log('ARTICLES HERE:', articles)

    result.B = articles.find(article => article.Product_description.includes('BQS')) ?? null;
    result.C = articles.find(article => article.Product_description.includes('C-Quali')) ?? null;

    const remainingForA = articles.filter(
        article =>
            !article.Product_description.includes('BQS') &&
            !article.Product_description.includes('C-Quali')
    );

    const aCandidates = remainingForA
        .map((a) => {
            const match = a.Product_description.match(/\d{3}/g);
            const max = match ? Math.max(...match.map(Number)) : 0;
            return { ...a, sortWeight: max };
        })
        .sort((a, b) => b.sortWeight - a.sortWeight);

    result.A = aCandidates[0] ?? null;
    result.A2 = aCandidates[1] ?? null;

    const classifiedProductNumbers = new Set<string>();
    for (const value of Object.values(result)) {
        if (value) classifiedProductNumbers.add(value.Product_number);
    }

    result.Q = articles.find(a => !classifiedProductNumbers.has(a.Product_number)) ?? null;

    return result;
}
